var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagerReopen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64258 9.77231C5.73228 8.91544 6.04669 8.09384 6.55689 7.38315C7.06708 6.67245 7.75666 6.09551 8.56215 5.7054C9.36762 5.3153 10.2631 5.12459 11.1663 5.15082C12.0693 5.17705 12.951 5.41938 13.73 5.8555C14.5091 6.29163 15.1605 6.90752 15.6244 7.64651C16.0882 8.38549 16.3496 9.22381 16.3843 10.0843C16.4191 10.9448 16.2263 11.7998 15.8235 12.5706C15.4282 13.3269 14.8434 13.9783 14.121 14.4673",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37695 7.69531C7.2105 8.51547 8.2086 9.16749 9.31187 9.61255C10.4152 10.0576 11.6011 10.2867 12.7992 10.286C13.9775 10.2871 15.1441 10.066 16.2318 9.63565",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84522 13.9453C9.54098 13.9453 9.24351 14.0313 8.99045 14.1925C8.73742 14.3536 8.54022 14.5826 8.42376 14.8506C8.30731 15.1185 8.27684 15.4133 8.3362 15.6978C8.39557 15.9823 8.54211 16.2436 8.75729 16.4486C8.97247 16.6538 9.24659 16.7935 9.54508 16.8501C9.84358 16.9066 10.1529 16.8775 10.4341 16.7666C10.7153 16.6556 10.9555 16.4676 11.1245 16.2264C11.2937 15.9854 11.3838 15.7017 11.3838 15.4118C11.3838 15.0229 11.2218 14.6498 10.9332 14.3748C10.6447 14.0998 10.2534 13.9453 9.84522 13.9453Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 11.4453V12.4992C3.6875 13.277 4.01171 14.023 4.5888 14.5731C5.1659 15.1231 5.9486 15.4321 6.76474 15.4321H8.22463",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 24.8441C21.0003 23.5772 20.4981 22.3348 19.5485 21.2521C18.6028 20.1737 17.2494 19.295 15.6348 18.7109",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24.8419C0.999795 23.5753 1.50165 22.3331 2.45087 21.2504C3.39534 20.1732 4.74668 19.2952 6.35884 18.711",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.851562C24.7092 0.851562 26.5 2.64242 26.5 4.85157C26.5 7.06068 24.7092 8.85157 22.5 8.85157C20.2909 8.85157 18.5 7.06068 18.5 4.85157C18.5 3.595 19.0794 2.47376 19.9856 1.74045",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.52344H20.2778V3.30122",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerReopen);
export default __webpack_public_path__ + "static/media/manager-reopen.26b57696db444204031703f3bbfc312f.svg";
export { ForwardRef as ReactComponent };